import { type FC } from 'react';
import classnames from 'classnames';

import { FormattedMessage } from 'dibs-react-intl';
import { Link } from 'dibs-elements/exports/Link.tsx';

import { trackTradeBenefitsEvent } from '../tradeBenefitsTracking.ts';

import styles from './TradeBenefitsFaq.scss';
import dibsCss from 'dibs-css';

const TradeBenefitsFaqFooter: FC = () => {
    return (
        <div className={classnames(styles.footer, dibsCss.textBodyHeaderMediumNormal)}>
            <FormattedMessage
                id="abt.TradeBenefitsFaqFooter.haveMoreQuestions"
                defaultMessage="<bold>Have more questions?</bold> See our <link>Trade 1st FAQs</link>"
                values={{
                    link: content => (
                        <Link
                            href="/info/trade-1st-faq/"
                            target="_blank"
                            onClick={() =>
                                trackTradeBenefitsEvent({
                                    stepInteractionName: 'view more faqs clicked',
                                    trigger: 'faq',
                                })
                            }
                        >
                            {content}
                        </Link>
                    ),
                    bold: content => (
                        <span
                            className={classnames(
                                styles.footerBold,
                                dibsCss.sassyFontBodyHeaderMediumHeavy
                            )}
                        >
                            {content}
                        </span>
                    ),
                }}
            />
        </div>
    );
};

export { TradeBenefitsFaqFooter };
